import React, { useState } from 'react';
import LayoutAuth from 'app/auth/layout';
import { FormStyled } from './index.styles';
import AppFormikInput from 'components/form/formik/input/input';
import { Formik } from 'formik';
import * as Yup from 'yup';
import ButtonSubmit from 'components/form/formik/button-submit';
import { H6 } from 'components/typography';
import { auth } from 'types';
import useSignInMutation from './hooks/use-sign-in-mutatuion';
import InputPassword from 'components/input/input-password';
import { toast } from 'react-toastify';
import messages from 'messages';
import { EMessagesAuthErrorResponseTypes } from 'types/messages';
import { EButtonType } from '../../../../components/control/button/button.types';

const signInFormInitValues: auth.TSignInParams = {
    email: '',
    password: '',
    code: '',
};

const signInFormValidationSchema = Yup.object({
    email: Yup.string().required().email(),
    password: Yup.string().required(),
});

const SignIn = () => {
    const [step, setStep] = useState(1);

    const [mutation, { isLoading }] = useSignInMutation({
        onSuccess: () => {
            toast.success(messages.auth.onSignIn.onSuccess);
        },
        onError: (e) => {
            if (e !== '2fa code is invalid') {
                setStep(1);
            }
            if (e === '2fa code is required') {
                setStep(2);
                return;
            }
            toast.error(
                messages.auth.onSignIn.onErrorSwitch(
                    e as EMessagesAuthErrorResponseTypes,
                ),
            );
        },
    });

    return (
        <LayoutAuth>
            <H6>Sign in</H6>
            <Formik
                validateOnChange={true}
                validateOnBlur={true}
                initialValues={signInFormInitValues}
                validationSchema={signInFormValidationSchema}
                onSubmit={async (values: auth.TSignInParams) => {
                    return mutation(values);
                }}
            >
                <FormStyled>
                    {step === 1 && (
                        <>
                            <AppFormikInput
                                name={'email'}
                                placeholder={'email'}
                            />
                            <AppFormikInput
                                component={InputPassword}
                                name={'password'}
                                placeholder={'password'}
                            />

                            <ButtonSubmit
                                wide
                                styleType={EButtonType.Primary}
                                isLoading={isLoading}
                            >
                                Sign in
                            </ButtonSubmit>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <AppFormikInput
                                name={'code'}
                                placeholder={'2FA Code'}
                            />

                            <ButtonSubmit
                                wide
                                styleType={EButtonType.Primary}
                                isLoading={isLoading}
                            >
                                Submit
                            </ButtonSubmit>
                        </>
                    )}
                </FormStyled>
            </Formik>
        </LayoutAuth>
    );
};

export default SignIn;
